const initInfrastructureTooltips = () => {
	const sections = document.querySelectorAll("section.infrastructure-tooltips");

	if (!sections.length) {
		return;
	}

	sections.forEach((component) => {
		component.querySelectorAll(".toggle").forEach((toggle) =>
			toggle.addEventListener("click", function () {
				toggle.classList.toggle("active");
				let iconType = toggle.dataset.type;
				console.log(toggle);
				component
					.querySelectorAll(`.point[data-type=${iconType}]`)
					.forEach((icon) => icon.classList.toggle("hidden"));
			})
		);

		component.querySelectorAll(".point").forEach((el) => {
			el.addEventListener("click", (e) => {
				closePopups(component);
				const about = el.querySelector(".about").cloneNode(true);
				about.classList.add("popup");

				if (about.dataset.image) {
					about.classList.add("with-image");
					about.style.backgroundImage = `url(${about.dataset.image})`;
				} else if (el.parentElement.classList.contains("main")) {
					component.querySelector(".full").classList?.add("with-opacity");
				}

                const categories = component.querySelector(".categories");
                if (window.innerWidth <= 700) {
                    categories.style.opacity = 0;
                }

				el.parentElement.parentElement.appendChild(about);
			});
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				closePopups(component);
			}
		});

		component.addEventListener("click", (e) => {
			if (!e.target.closest(".point")) {
				closePopups(component);
			}
		});
	});

	const closePopups = (component) => {
		component.querySelectorAll(".popup").forEach((el) => {
			el.remove();
		});
		component.querySelectorAll(".with-opacity").forEach((el) => {
			el.classList.remove("with-opacity");
		});
        const categories = component.querySelector(".categories");
        if (window.innerWidth <= 540) {
            categories.style.opacity = 1;
        }
	};
};

export { initInfrastructureTooltips };
